// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3BfsL","content":"styles_content__u1sXF","checkbox":"styles_checkbox__2omQr","checkboxLabel":"styles_checkboxLabel__H6Hnd"};